// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import VueCarousel from 'vue-carousel'
import VueGtag from "vue-gtag";

import router from './router'
import { store } from './store/store'
import { shared } from './globalConfig.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faJs, faFacebookF, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import {
    faCertificate, faChalkboardTeacher, faClock, faThumbsUp, faThumbsDown
} from '@fortawesome/free-solid-svg-icons';

import {
  faThumbsUp as farThumbsUp, faThumbsDown as farThumbsDown
} from '@fortawesome/free-regular-svg-icons';

import VueAxios from 'vue-axios'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

library.add(faJs, faFacebookF,faTwitter,faInstagram, faCertificate, faChalkboardTeacher, faClock, faThumbsUp, faThumbsDown, farThumbsDown, farThumbsUp, faLinkedin)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueCarousel)
Vue.use(shared,{current_app:process.env.VUE_APP_THIS_APP})
Vue.use(VueGtag, {
  config: { id: "" },
  bootstrap: false
},router);

Vue.config.productionTip = false

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})




// WEBPACK FOOTER //
// ./src/main.js